import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/mediaPipeline/useMediaPipelineQueryKeys.ts
var t = e("admin-media-pipeline", {
	summary: (e) => ["summary", e ?? "7d"],
	failures: (e, t, n) => [
		"failures",
		e ?? "7d",
		t ?? "all",
		n ?? ""
	]
});
//#endregion
export { t as mediaPipelineQueryKeys };
